/**
 * Payload schemaVersion 1, chartTypes:
 * - conversationsByCollaboratorWeekly
 * - reembolsosSolicitadosRevertidosWeekly
 *
 * Estrutura:
 * - categories: [{ key, label }] — meses no eixo X
 * - series: [{ key, label, color?, order }]
 * - weekKeys: ['1','2','3','4']
 * - values: { [seriesKey]: { [monthKey]: { [weekKey]: number } } }
 * Gráfico: soma das semanas por mês e por série (barras verticais agrupadas).
 * Eixo Y: options.valueAxis.step (se definido e > 0); senão padrão 50. max opcional.
 */
function sumWeeksForMonth(values, collabKey, monthKey, weekKeys) {
  const monthBlock = values?.[collabKey]?.[monthKey]
  if (!monthBlock || typeof monthBlock !== 'object') return 0
  return weekKeys.reduce((acc, w) => {
    const n = Number(monthBlock[w] ?? 0)
    return acc + (Number.isFinite(n) ? n : 0)
  }, 0)
}

export function payloadToConversationsByCollaboratorWeeklyChartjs(payload) {
  const p = payload || {}
  const categories = Array.isArray(p.categories) ? p.categories : []
  const seriesDefs = Array.isArray(p.series) ? p.series : []
  const values = p.values && typeof p.values === 'object' ? p.values : {}
  const weekKeys = Array.isArray(p.weekKeys) && p.weekKeys.length ? p.weekKeys.map(String) : ['1', '2', '3', '4']

  const labels = categories.map((c) => c?.label ?? '')
  const categoryKeys = categories.map((c) => c?.key ?? '')

  const ordered = [...seriesDefs].sort((a, b) => Number(a?.order ?? 0) - Number(b?.order ?? 0))
  const datasets = ordered.map((s) => {
    const key = String(s?.key ?? '')
    const data = categoryKeys.map((ck) => {
      const total = sumWeeksForMonth(values, key, ck, weekKeys)
      return total === 0 ? null : total
    })
    return {
      label: String(s?.label ?? key),
      backgroundColor: String(s?.color ?? '#2563eb'),
      borderColor: String(s?.color ?? '#2563eb'),
      borderWidth: 1,
      data,
    }
  })

  const axis = p.options?.valueAxis || {}
  const min = Number.isFinite(Number(axis.min)) ? Number(axis.min) : 0
  const max = Number.isFinite(Number(axis.max)) ? Number(axis.max) : undefined
  const stepOpt = Number(axis.step)
  const yStep = Number.isFinite(stepOpt) && stepOpt > 0 ? stepOpt : 50

  return {
    data: { labels, datasets },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: true, position: 'bottom', labels: { boxWidth: 12, padding: 10 } },
      plugins: {
        datalabels: { display: false },
      },
      scales: {
        xAxes: [
          {
            gridLines: { display: false },
            ticks: { maxRotation: 45, minRotation: 45 },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              min,
              stepSize: yStep,
              ...(max !== undefined ? { max } : {}),
            },
            gridLines: { display: true },
          },
        ],
      },
    },
  }
}
